import { toPlutusDataInvestUnitType, toPlutusDataOracleReIdx_Data } from '../conversions';
import { Convertible } from '../index.exports';
import { type OracleReIdx_Data, type TokensForInvestUnitDatum } from '../types';
import { BaseTxRedeemer } from '../../Entities/index.exports';

export type InvestUnitValidatorRedeemer = InvestUnitValidatorRedeemerReIndexing | InvestUnitValidatorRedeemerUpdateMinADA | InvestUnitValidatorRedeemerEmergency | InvestUnitValidatorRedeemerDelete;

export class InvestUnitValidatorRedeemerReIndexing extends BaseTxRedeemer {
    protected static _plutusDataIndex = 0;
    protected static _plutusDataIsSubType = true;

    @Convertible({
        isForRedeemer: true,
        toPlutusData: toPlutusDataInvestUnitType,
    })
    riuriTokensToAdd!: TokensForInvestUnitDatum;

    @Convertible({
        isForRedeemer: true,
        toPlutusData: toPlutusDataInvestUnitType,
    })
    riuriTokensToRemove!: TokensForInvestUnitDatum;

    @Convertible({
        isForRedeemer: true,
        toPlutusData: toPlutusDataOracleReIdx_Data,
    })
    riuriOracleReIdx_Data!: OracleReIdx_Data;

    @Convertible({ isForRedeemer: true })
    riuriOracleSignature!: string; //Signature
}

export class InvestUnitValidatorRedeemerUpdateMinADA extends BaseTxRedeemer {
    protected static _plutusDataIndex = 1;
    protected static _plutusDataIsSubType = true;
}

export class InvestUnitValidatorRedeemerEmergency extends BaseTxRedeemer {
    protected static _plutusDataIndex = 2;
    protected static _plutusDataIsSubType = true;
}

export class InvestUnitValidatorRedeemerDelete extends BaseTxRedeemer {
    protected static _plutusDataIndex = 3;
    protected static _plutusDataIsSubType = true;
}
